import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TopMenuLeft from "./TopMenuLeft";
import { TopMenuRight } from "./TopMenuRight";
import Media from "react-media";
import moment from "moment";

class AboveFilterDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPage: 1,
      pathname: "",
    };
  }

  componentDidMount() {
    this.comparePathName();
  }
  componentDidUpdate() {
    this.comparePathName();
  }
  comparePathName = (e) => {
    if (this.props.pathname !== this.state.pathname) {
      if (this.props.pathname.includes("offline-event-details")) {
        this.setState({ selectedPage: 1, pathname: this.props.pathname });
      } else if (this.props.pathname.includes("offline-events-pending")) {
        this.setState({ selectedPage: 2, pathname: this.props.pathname });
      } else if (this.props.pathname.includes("offline-events-booked")) {
        this.setState({ selectedPage: 3, pathname: this.props.pathname });
      } else if (this.props.pathname.includes("offline-events-history")) {
        this.setState({ selectedPage: 4, pathname: this.props.pathname });
      } else if (this.props.pathname.includes("offline-events-all")) {
        this.setState({ selectedPage: 5, pathname: this.props.pathname });
      }
    }
  };
  render() {
    return (
      <React.Fragment>
        <Container fluid>
          {/* {console.log(this.props.dataProps)} */}
          <Row>
            <Media query="(max-width: 992px)">
              <MiddleMenu
                startDate={
                  this.props.dataProps && this.props.dataProps.start_date
                }
                endDate={this.props.dataProps && this.props.dataProps.end_date}
              />
            </Media>
            <Media query="(max-width: 992px)">
              <div className="w-100 ">
                <hr className="mb-0" />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <TopMenuLeft
                pathname={this.props.pathname}
                selectedPage={this.state.selectedPage}
                totalCountPending={this.props.pendingLength}
                totalCountRsvp={this.props.rsvpLength}
                totalCountTicket={this.props.ticketLength}
                dataProps={this.props.dataProps}
              />
            </Media>
            <Media query="(min-width: 992px)">
              <TopMenuLeft
                pathname={this.props.pathname}
                selectedPage={this.state.selectedPage}
                totalCountPending={this.props.pendingLength}
                totalCountRsvp={this.props.rsvpLength}
                totalCountTicket={this.props.ticketLength}
                dataProps={this.props.dataProps}
              />
            </Media>
            <Media query="(min-width: 992px)">
              <MiddleMenu
                startDate={
                  this.props.dataProps && this.props.dataProps.start_date
                }
                endDate={this.props.dataProps && this.props.dataProps.end_date}
                dataProps={this.props.dataProps}
                selectedPage={this.state.selectedPage}
              />
            </Media>
            {/* {this.state.pathname !== "/offline-events-booked" && (
              <Media query="(min-width: 992px)">
                <TopMenuRight />
              </Media>
            )} */}
          </Row>
          <Media query="(min-width: 992px)">
            <div className="w-100">
              <hr />
            </div>
          </Media>
        </Container>
      </React.Fragment>
    );
  }
}

export const MiddleMenu = (props) => {
  return (
    <React.Fragment>
      <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 middle-menu-events-top">
        <Row>
          <Col style={{ borderLeft: "1px solid #E0E0E0" }}>
            <div className="f16-500 py-2">Event Date & Time</div>
            <p className="f12-400">
              {moment(props.startDate).format("Do MMM, YYYY")} &nbsp; To &nbsp;{" "}
              {moment(props.endDate).format("Do MMM, YYYY")}
            </p>
            <p className="f12-400">
              {moment(props.startDate).format("hh:mm A")} &nbsp; To &nbsp;{" "}
              {moment(props.endDate).format("hh:mm A")}
            </p>
          </Col>
          {props?.selectedPage === 1 || props?.selectedPage === 3 ? (
            <Col style={{ borderLeft: "1px solid #E0E0E0" }}>
              <div className="f16-500 py-2">Maximum Number</div>
              <p className="f12-400">
                <p className="f12-400">
                  {props?.selectedPage === 1
                    ? props?.dataProps?.maxGuest_RSVP
                    : props?.dataProps?.total_quantity_TB}
                </p>
              </p>
            </Col>
          ) : null}
          {props?.selectedPage === 1 || props?.selectedPage === 3 ? (
            <Col style={{ borderLeft: "1px solid #E0E0E0" }}>
              <div className="f16-500 py-2">Buffer Number</div>
              <p className="f12-400">
                {props?.selectedPage === 1
                  ? props?.dataProps?.buffer_RSVP_guest
                  : props?.dataProps?.buffer_TB_guest}
              </p>
            </Col>
          ) : null}
          {props?.selectedPage === 1 || props?.selectedPage === 3 ? (
            <Col style={{ borderLeft: "1px solid #E0E0E0" }}>
              <div className="f16-500 py-2">Left Count</div>
              <p className="f12-400">
                {props?.selectedPage === 1
                  ? props?.dataProps?.leftOverRSVP
                  : props?.dataProps?.leftOverTB}
              </p>
            </Col>
          ) : null}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default AboveFilterDesc;
